var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.602 127.166H126.665M126.602 127.166C122.451 131.283 114.927 130.258 109.651 130.258C103.175 130.258 100.057 131.524 95.4347 136.146C91.4994 140.082 86.2234 147.166 79.9987 147.166C73.774 147.166 68.498 140.082 64.5625 136.146C59.9406 131.524 56.822 130.258 50.3458 130.258C45.0699 130.258 37.5466 131.283 33.3953 127.166C29.2108 123.017 30.2406 115.462 30.2406 110.152C30.2406 103.442 28.7731 100.357 23.9946 95.5783C16.8863 88.4703 13.3322 84.9157 13.332 80.4997C13.3321 76.083 16.8862 72.529 23.9944 65.4208C28.26 61.1551 30.2406 56.9282 30.2406 50.8467C30.2406 45.5707 29.2153 38.0473 33.332 33.8959C37.4816 29.7115 45.036 30.7414 50.3459 30.7414C56.4272 30.7414 60.6542 28.761 64.9197 24.4955C72.028 17.3871 75.582 13.833 79.9987 13.833C84.4154 13.833 87.9694 17.3871 95.0774 24.4955C99.342 28.7601 103.569 30.7414 109.651 30.7414C114.927 30.7414 122.451 29.7161 126.603 33.833C130.787 37.9825 129.757 45.5369 129.757 50.8467C129.757 57.5569 131.225 60.6421 136.003 65.4208C143.111 72.529 146.665 76.083 146.665 80.4997C146.665 84.9157 143.111 88.4703 136.003 95.5783C131.224 100.357 129.757 103.442 129.757 110.152C129.757 115.462 130.787 123.017 126.602 127.166Z",
    stroke: "#2B52D2",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 86.4526C60 86.4526 68 90.7979 72 97.1666C72 97.1666 84 72.1666 100 63.8333",
    stroke: "#2B52D2",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBadge);
export default __webpack_public_path__ + "static/media/checkmark-badge.3841305c29085d0720035f4452a3e7f8.svg";
export { ForwardRef as ReactComponent };